// extracted by mini-css-extract-plugin
export default {"container":"ImportInfo_container__9QKIu","infoSection":"ImportInfo_infoSection__rVJcL"};